import { Box, Card, Paper } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import Tooltip from '@mui/material/Tooltip';
import MDTypography from 'components/MDTypography';
import { getRoleDisplay } from '../../types/roles';
import { useLocation, useNavigate } from 'react-router-dom';

const getBuildingListNames = buildingsNames => {
  let buildingsNamesText = buildingsNames.slice(0, 2).join(', ');
  if (buildingsNamesText.length > 23) {
    return `( ${buildingsNames[0]} + ${buildingsNames.length - 1} more )`;
  }
  return `( ${buildingsNamesText} )`;
};

export const PermissionUserCard = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleUserClick = () => {
    if (location.pathname === '/manage-permissions/users') {
      navigate(`/manage-permissions/users/${props.id}`);
    }
  };

  const AvatarIcon = props.role === 's' ? AdminPanelSettingsIcon : AccountCircleIcon;

  return (
    <Card
      onClick={handleUserClick}
      sx={{
        width: {
          xs: '325px',
          '&:hover': {
            cursor: 'pointer',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transform: 'translateY(-2px)',
            transition: 'all 0.2s ease-in-out',
          },
        },
        transition: 'all 0.2s ease-in-out',
      }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        ml={1}
        mr={1.25}
        my={-0.5}
        sx={{
          padding: '12px 0px 4px 0px',
        }}>
        <Box className="container">
          <Box
            className="topContainer"
            sx={{
              display: 'flex',
              width: '19.5rem',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}>
              <Paper
                className="userStatusIcon"
                color={'white'}
                elevation={1}
                style={{
                  background: props.role === 's' ? 'black' : 'blue',
                }}
                sx={{
                  padding: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '3rem',
                  height: '3rem',
                }}>
                <AvatarIcon
                  sx={{
                    color: '#fff',
                    scale: '2',
                    '&:hover': {
                      color: '#fffff',
                    },
                  }}
                />
              </Paper>
              <MDTypography
                fontSize={16}
                sx={{
                  overflowWrap: 'anywhere',
                  marginLeft: '1rem',
                  fontWeight: 'bold',
                  color: '#000',
                }}>
                {props.username}
              </MDTypography>
            </Box>
          </Box>
          <Box sx={{ marginTop: '.5rem', width: '19rem' }}>
            <Tooltip
              title={
                <div style={{ textAlign: 'left' }}>
                  <strong>Role:</strong> {getRoleDisplay(props.role)}
                  <br />
                  <strong>Buildings:</strong>{' '}
                  {props.buildingNames?.length > 0 ? props.buildingNames.join(', ') : 'No permissions'}
                  {props.role === 'd' && (
                    <>
                      <br />
                      <strong>Customers:</strong>{' '}
                      {props.customerNames?.length > 0 ? props.customerNames.join(', ') : 'No customers'}
                    </>
                  )}
                </div>
              }>
              <MDTypography
                fontSize={14}
                sx={{
                  fontWeight: 'regular',
                  color: '#000',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  marginLeft: '',
                }}>
                <>
                  <div>
                    <strong>Role:</strong> {getRoleDisplay(props.role)}
                  </div>
                  {props.role !== 's' && (
                    <>
                      <div>
                        <strong>Buildings:</strong> {props.buildingNames.length || 0}
                        {props.buildingNames?.length > 0 && (
                          <span style={{ color: '#666', fontSize: '12px' }}>
                            {' '}
                            {getBuildingListNames(props.buildingNames)}
                            {/* ({props.buildingNames.slice(0, 2).join(', ')} */}
                            {/* {props.buildingNames.slice(0, 2).join(', ').length > 23 && `, +${props.buildingNames.length - 2} more`}) */}
                          </span>
                        )}
                      </div>
                      <div>
                        <strong>Areas:</strong> {props.totalAreas || 0}
                      </div>
                    </>
                  )}
                  {props.role === 'd' && (
                    <div>
                      <strong>Customers:</strong> {props.customerNames.length || 0}
                      {props.customerNames?.length > 0 && (
                        <span style={{ color: '#666', fontSize: '12px' }}>
                          {' '}
                          ({props.customerNames.slice(0, 2).join(', ')}
                          {props.customerNames.length > 2 && `, +${props.customerNames.length - 2} more`})
                        </span>
                      )}
                    </div>
                  )}
                </>
              </MDTypography>
            </Tooltip>
          </Box>
        </Box>
      </Box>

      {/* Permission Status Indicator */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '7px 16px',
          borderTop: '1px solid #f0f0f0',
        }}>
        {props.role !== 's' && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                backgroundColor: props.buildingNames.length > 0 ? '#4caf50' : '#f44336',
              }}
            />
            <MDTypography fontSize={12} color="text.secondary">
              {props.buildingNames.length > 0 ? 'Has Permissions' : 'No Permissions'}
            </MDTypography>
          </Box>
        )}
        <MDTypography fontSize={12} color="primary" sx={{ fontWeight: 'bold' }}>
          {props.cardClickInfo}
        </MDTypography>
      </Box>
    </Card>
  );
};

export default PermissionUserCard;
